import { configureStore } from "@reduxjs/toolkit"
import authReducer from "../features/auth/authSlice"
import { authApi } from "../features/auth/authApi"
import { adminApi } from "../features/admin/adminApi"

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
  },
  middleware: (getDefault) =>
    getDefault().concat(authApi.middleware, adminApi.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
